import { render, staticRenderFns } from "./listagemMultasVeiculos.vue?vue&type=template&id=2405f00b&scoped=true"
import script from "./listagemMultasVeiculos.vue?vue&type=script&lang=js"
export * from "./listagemMultasVeiculos.vue?vue&type=script&lang=js"
import style0 from "./listagemMultasVeiculos.vue?vue&type=style&index=0&id=2405f00b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2405f00b",
  null
  
)

export default component.exports